import Marquee from "react-fast-marquee";

const ITEMS = [
  "Director",
  "Virtual Production",
  "Unreal Engine 5",
  "Cinematography",
  "Real-Time VFX",
  "Worldbuilding",
];

export const EditorialMarquee = () => {
  return (
    <div
      data-testid="marquee"
      className="border-y border-white/10 bg-[#0f0f11] py-6 select-none"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span
            key={i}
            className="mx-8 font-bebas text-4xl md:text-6xl tracking-widest uppercase flex items-center gap-8 text-neutral-200"
          >
            {item}
            <span className="text-[#e1ff00] text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
